// 各ステップの既存Controller名。最終送信は従来どおりフォーム全体を検証する。
export const registrationStepFields = {
  own: [
    [
      "name",
      "room_number",
      "floor",
      "prefecture",
      "city",
      "town",
      "railway",
      "station",
      "walk",
      "built_at",
      "occupied_area_m2",
      "layout",
      "structure",
      "management_type",
      "sales_status",
      "bought_at",
      "bought_at_day",
      "property_image",
    ],
    [
      "total_price_of_property",
      "priceof_tax",
      "priceof_building",
      "priceof_land",
      "loan_amount",
      "loan_interest_rate_percentage",
      "payment_starts_at",
      "payment_period",
    ],
    [
      "monthly_fee",
      "monthly_management_fee",
      "type_of_the_income_of_the_beginning_of_contract",
      "security_deposit",
      "key_money",
      "building_management_cost",
      "repair_fund_cost",
      "management_cost",
      "misc_cost",
      "outsourcing_fee_rate_of_new_lease_contract",
      "outsourcing_fee_rate_of_updating_lease_contract",
      "starts_at",
      "starts_at_day",
      "ends_at",
      "ends_at_day",
      "asking_price",
    ],
  ],
  building: [
    [
      "name",
      "room_number",
      "prefecture",
      "city",
      "town",
      "railway",
      "station",
      "walk",
      "built_at",
      "structure",
      "management_type",
      "sales_status",
      "bought_at",
      "bought_at_day",
      "property_image",
    ],
    [
      "total_price_of_property",
      "priceof_tax",
      "priceof_building",
      "priceof_land",
      "loan_amount",
      "loan_interest_rate_percentage",
      "payment_starts_at",
      "payment_period",
    ],
    ["monthly_fee", "other_monthly_income", "starts_at", "starts_at_day", "ends_at", "ends_at_day"],
    ["management_company_commission", "shared_utility_expenses", "misc_building_cost", "asking_price"],
  ],
  consideration: [
    [
      "name",
      "room_number",
      "floor",
      "prefecture",
      "city",
      "town",
      "railway",
      "station",
      "walk",
      "built_at",
      "occupied_area_m2",
      "layout",
      "structure",
    ],
    [
      "bought_at",
      "bought_at_day",
      "total_price_of_property",
      "priceof_tax",
      "priceof_building",
      "priceof_land",
      "loan_amount",
      "loan_interest_rate_percentage",
      "payment_starts_at",
      "payment_period",
    ],
    [
      "monthly_fee",
      "monthly_management_fee",
      "type_of_the_income_of_the_beginning_of_contract",
      "security_deposit",
      "key_money",
      "building_management_cost",
      "repair_fund_cost",
      "management_cost",
      "misc_cost",
      "outsourcing_fee_rate_of_new_lease_contract",
      "outsourcing_fee_rate_of_updating_lease_contract",
      "starts_at",
      "starts_at_day",
      "ends_at",
      "ends_at_day",
    ],
  ],
} as const;
export type RegistrationFlow = keyof typeof registrationStepFields;
export const getRegistrationStepFields = <F extends RegistrationFlow>(
  flow: F,
  step: number
): Array<(typeof registrationStepFields)[F][number][number]> =>
  [...registrationStepFields[flow][step]] as Array<(typeof registrationStepFields)[F][number][number]>;
